import type { MentionItem } from '@/components/stella/types'

interface NamedProduct {
  id: string
  name: string
}

export const withProductId = (
  mention: MentionItem,
  productId?: string
): MentionItem =>
  mention.productId || !productId ? mention : { ...mention, productId }

export const withProductName = (
  mention: MentionItem,
  products: NamedProduct[]
): MentionItem => {
  if (mention.productName || !mention.productId) {
    return mention
  }

  const product = products.find((scope) => scope.id === mention.productId)

  return product ? { ...mention, productName: product.name } : mention
}

export const findProductIdsMissingNames = (
  mentions: MentionItem[]
): string[] => [
  ...new Set(
    mentions.flatMap((mention) =>
      mention.productId && !mention.productName ? [mention.productId] : []
    )
  ),
]
